<template>
  <div>
    <div class="installerContainer">
      <a class="installerTile" :href="`${packagesBaseUrl}-${latestVersion}.zxp`">
        <img class="osLogo" style="height: 1.2rem;" src="img/package.svg">
        <div style="flex-direction:row;">
          <span >Extension</span>
          <br/>
          <span class="latestBadge">LATEST</span>          
        </div>
      </a>
      <a class="installerTile" :href="`${packagesBaseUrl}-cc-installer.zip`">
        <div style="flex-direction:row; padding-top:1rem;">
          <img class="osLogoSmall" src="img/mac-os-logo.svg">
          <img class="osLogoSmall"  src="img/windows-logo.svg">
        </div>
        Installer
      </a>
    </div>
    <div class='versionList'>
      <div class='versionSection' v-for="(versionNotes, version, vkey) in versions" :key="version">
        <div class='versionHeading'>
          <div class="installerContainer">
            <a class="installerSmall" :href="`${packagesBaseUrl}-${version}.zxp`">
              <img class="osLogoSmall"  src="img/package.svg">
            </a>
          </div>
          <div style="margin-left:0.6rem;"><b>{{
            (versionNotes.filter(n => n.info)||[]).map(i => i.info).join(' ') 
            
            
            
            || 'Release Info'



          }}</b></div>
          <span v-if="vkey==0" class="latestBadge">LATEST</span>

        </div>
        
        <div style="padding-bottom:0.4rem; font-size:.66rem; opacity: 0.46;">Version: <i><b>{{version}}</b></i></div>

        <div class='versionNote' v-for="note in versionNotes.filter(n => n.text)" :key="note.text" >
          {{note.text}}
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: "Installers",
  data: function() {
    return {
      packagesBaseUrl: 'https://extensions.tenovos.io/storylink/packages/storyLink',
      latestVersion: '25.300',
      versions: {
        '25.300': [
          { info: 'June 2025'},
          { text: 'Updated search for replacement assets during validation.'},
          { text: 'Simplified Profile Management. NOTE: Contact Support for your Connection Key.'},
        ],
        // '24.406': [
        //   { info: 'Oct 2024'},
        //   { text: 'Added support for Auth0 and Tenovos API v1.5.'},
        // ],
        // '24.374': [
        //   { info: 'Sep 2024'},
        //   { text: 'Enhanced session management with API calls.'},
        // ],
        // '24.011': [
        //   { info: 'Jan 2024'},
        //   { text: 'Support for Adobe CC 2024.'},
        //   { text: 'InDesign: Ability to retain Layer Options for placed PSD and AI files.'},
        //   { text: 'InDesign: Fixed layer visibility issues upon validation (CC 2024 only).'},
        // ],
      }
    };
  },  
};

/*
  '23.441': [
    { info: 'Oct 2023'},
    { text: 'Illustrator: Fixed issues with placed EPS/PSD images in the project.'},
    { text: 'InDesign: Fixed issues while validating the placed graphics.'},
  ],
  '23.274': [
    { info: 'July 2023'},
    { text: 'Extracting unique Ids from the file path for faster load times.'},
    { text: 'Success message when documents are successfully saved.'},
    { text: 'InDesign: Adjusted content position to center when placing in an existing frame.'},
    { text: 'Updates to filename for the High Res files. Removing "fpo" designation.'},
  ],
  '23.201': [
    { info: 'June 2023'},
    { text: 'Added support for placing HEIC file type as graphics.'},
    { text: 'Updated API services with embedded retry mechanism.'},
  ],
  '23.084': [
    { info: 'February 2023'},
    { text: 'Added support for Adobe CC 2023.'},
    { text: 'InDesign: Placment of Hi Res AI content based on file size.'},
    { text: 'Bypass system generated link based on Srouce field assignment.'},
  ],
  '22.433': [
    { info: 'October 2022'},
    { text: 'InDesign: Support for system generated links to placed graphics.'},
    { text: 'Minor bug fixes in Illustrator and Photoshop workflows.'},
  ],        
  '22.321': [
    { info: 'August 2022'},
    { text: 'InDesign: Ability to link Text files as linked assets.'},
    { text: 'Fixed issues with Missing links for InDesign.'},
  ],
  '22.263': [
    { info: 'June 2022'},
    { text: 'Minor bug fixes for Photoshop and InDesign.'},
    { text: 'Updates to the asset validation process.'},
  ],
  '22.246': [
    { info: 'May 2022'},
    { text: 'Enhanced review process in Illustrator.'},
    { text: 'Updated file transfer module for downloads.'},
  ],
  '22.165': [
    { info: 'April 2022'},
    { text: 'Enhanced suoport for Adobe 2022.'},
    { text: 'Minor bug fixes and updates to Photoshop workflows.'},
  ],
  '21.451': [
    { info: 'November 2021'},
    { text: 'Adding support for the art layers in Photoshop.'},
    { text: 'Enhanced routines to detect InDesign links.'},
    { text: 'General updates and maintenance.'},
  ],
  '21.351': [
    { text: 'Fixed issues related to saving asset while creating a version.'},
  ],
  '21.266': [
    { text: 'Updated document save frequency to optimize open and store operations.'},
    { text: 'Ability to change search tags in user settings, after selecting a preset.'},
    { text: 'Enforce read only fields on the metadata panel.'},
    { text: 'General bug fixes and enhancements.'},
  ],        
  '21.214': [
    { text: 'Derivates: Advanced options for generating derivates with various settings.'},
    { text: 'Validating Assets: Enhanced asset validation flow to minimize document refresh.'},
    { text: 'Excluded Filters: Ability to suppress Facets based on user preference.'},
    { text: 'Search Presets: Choose from a predefined list of search presets.'},
  ],
  '21.192': [
    { text: 'Metadata Entry: Ability to assign metadata values to attributes while saving to DAM'},
    { text: 'Filtered results based on the Adobe CC application context'},
    { text: 'Retain attribute values from previous data entry session'},
    { text: 'Assign predefined search criteria in user preferences'},
    { text: 'Various performance enhancements'}
  ],
*/


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.installerContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: auto;
  text-align: center;
}

a:link {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

.installerTile{
  display: flex;
  flex-direction: column;  
  width: 12rem;
  height: 6rem;
  padding: .5rem;
  margin: .25rem;
  color:#777 !important;
  text-align: center;
  cursor: pointer;
  background-color: rgb(232, 231, 231);
  border: grey;
  border-width: .5rem;
}

.installerSmall{
  display: flex;
  flex-direction: column;  
  width: 2rem;
  height: auto;
  padding: .1rem;
  margin: .12rem .2rem .12rem 0rem;
  text-align: center;
  cursor: pointer;
  background-color: rgb(232, 231, 231);

  border-width: .25rem;
}

.versionList{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
  font-size: .84rem;
}

.versionSection{
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: left;
  width: 32rem;
  margin: .72rem 0;
}

.versionHeading{
  display: flex;
  flex-direction: row; 
  align-items: center;
  justify-content: center;
  margin: 1rem .2rem;
  font-size: 1rem;
}

.versionNote{
  width: 100%;
  padding: .6rem;
  margin-bottom: .1rem;
  font-size: .8rem;
  text-align: left;
  background-color: rgb(230, 239, 242);
}
.latestBadge{
  padding: .2rem .6rem;
  margin: 0 .5rem;
  font-size: .46rem;
  font-weight: 600;
  color: white;
  background-color: rgb(32, 170, 255);
  border-radius: .25rem;

}

.osLogo{
  width: auto;
  height: 2rem;
  padding: 1rem;
}

.osLogoSmall{
  width: auto;
  height: 1rem;
  padding: .5rem;
}

</style>
